import lottie from 'lottie-web';

const lottieAnimation = () => {
    const lottieContainers = document.querySelectorAll('.js-lottie-animation');

    if (lottieContainers) {
        lottieContainers.forEach(lottieContainer => {
            const { path, assetsPath} = lottieContainer.dataset;

            lottie.loadAnimation({
                container: lottieContainer,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                path: path,
                assetsPath: assetsPath
            });
        })
    }
};

export default lottieAnimation;
